<template>
  <div class="home">
    <van-loading v-show="show" type="spinner" class="home-loadings" color="#1989fa" />
    <div v-if="!show">
      <div data-v-54b6c2fa class="van-cell-group van-hairline--top-bottom">
        <div data-v-54b6c2fa class="van-cell">
          <div data-v-54b6c2fa class="van-cell__title-titles">
            <span data-v-54b6c2fa>提现金额</span>
            <div data-v-54b6c2fa class="van-cell__label van-cell__labels">
              <span>￥</span>
              <input
                @click="$refs.value.focus()"
                type="text"
                v-model="value"
                min="100"
                ref="value"
                placeholder="请输入金额"
                @input="checkInput"
                class="van-field__control"
              />
            </div>
          </div>
        </div>
        <div data-v-54b6c2fa class="van-cell">
          <div data-v-54b6c2fa class="van-cell__title">
            <!-- <span data-v-54b6c2fa></span> -->
            <p>
              <span>可提现金额:</span>
              <span
                style="color: #fa6563ff;"
                class="van-cell__title-money"
              >￥ {{ Math.floor((list.balance/1000)* 100) / 100 }}</span>
            </p>
          </div>
          <div data-v-54b6c2fa class="van-cell__value-value">
            <span data-v-54b6c2fa @click.stop="all">全部提现</span>
          </div>
        </div>
      </div>
      <p class="home-boundary"></p>
      <div data-v-54b6c2fa class="home-van-cell__value-value">
        <div data-v-54b6c2fa class="van-cell">
          <div data-v-54b6c2fa class="van-cell__title">
            <span data-v-54b6c2fa>提现方式</span>
          </div>
          <div data-v-54b6c2fa class="van-cell__value">
            <span data-v-54b6c2fa>微信</span>
          </div>
        </div>
        <div data-v-54b6c2fa class="van-cell">
          <div data-v-54b6c2fa class="van-cell__title van-cell__title-inputs">
            <span data-v-54b6c2fa>微信号</span>
            <input
              @click="$refs.valuelist.focus()"
              ref="valuelist"
              placeholder="请输入微信号"
              v-model="valuelist"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="home-cell__value-boundary">
        <span>提现说明：</span>
        <p v-html="list.remarks">{{list.remarks}}</p>
      </div>
      <div class="home-cell__value-buttom">
        <van-button round @click="withdrawals" type="primary">立即提现</van-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { withdrawalInfo, withdrawal } from "../../api/Deposit/Deposit";
import { request, https } from "@/utils/https";
import { Toast } from "vant";
import { getUserToken } from "@/utils/Cookie";
export default {
  name: "Deposit",

  data() {
    return {
      value: "",
      valuelist: "",
      list: [],
      show: true,
      account_token: ''
    };
  },
  watch: {
    value(val) {
      console.log(val);
      val = Math.floor(val * 100) / 100;
    },
  },
  methods: {
    all() {
      this.value = parseInt(this.list.balance);
      this.value = Math.floor((this.value / 1000) * 100) / 100;
    },
    funcs() {
      this.$router.back();
    },
    checkInput() {
      this.value = this.dealInputVal(this.value);
    },
    dealInputVal(value) {
      value = value.replace(/^0*(0\.|[1-9])/, "$1");
      value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      value = value.replace(/\.{1,}/g, "."); //只保留第一个.清除多余的
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      value = value.replace(/^(-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      value =
        value.indexOf(".") > 0
          ? value.split(".")[0].substring(0, 10) + "." + value.split(".")[1]
          : value.substring(0, 10);
      if (value == "") {
        this.disabled = true;
      } else if (value == Number(0)) {
        this.disabled = true;
      } else if (value == "0.") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      return value;
    },
    async withdrawalInfos() {
      let res = await request(
        "user/person/withdrawalInfo?token=" + getUserToken()
      );
      if (res.data) {
        this.show = false;
        this.list = res.data;
      }
    },
    async withdrawals() {
      if (!this.value) {
        Toast("金额不能为空");
        return;
      }
      if (!this.valuelist) {
        Toast("微信账号不能为空");
        return;
      }
      if (this.value == 0) {
        Toast(`提现金额不能为0`);
        return;
      }
      if (this.list.balance == 0) {
        Toast(`可提现金额为0`);
        return;
      }
      if ((this.value % this.list.money != 0) && this.list.money != 0) {
        Toast(`提现金额是${this.list.money}的整倍数`);
        return;
      }
      if (this.value < parseInt(this.list.mini_money)) {
        Toast(`金额不能小于${this.list.mini_money}元`);
        return;
      }
      if (this.value <= Math.floor((this.list.balance / 1000) * 100) / 100) {
        let data = {
          account_role: "distribution",
          account_source: "mp",
        };
        //获取授权信息
        let ser = await https(
          "funds/official/authInfo?token=" + getUserToken()+"&mtoken=805c4ad7f0a4a2854c95f505027ff0fe&btoken=da3dc3b909b5ff975017ccc06b4878b4",
          data
        );
        if (!ser.data) {
          //去授权
          let scr = await https(
            "funds/official/authSpliceUrl?token=" + getUserToken()+"&mtoken=805c4ad7f0a4a2854c95f505027ff0fe&btoken=da3dc3b909b5ff975017ccc06b4878b4",
            data
          );
          if (scr.data) {
            const url = scr.data.url;
            window.location.href = url;
          }
        } else {
          this.toPromotion(ser.data.account_token)
        }
      } else {
        
        Toast("输入金额不能小于提现金额");
      }
    },
    //提现记录
    async toPromotion(account_token) {
      let data = {
          total_money: (Math.floor(this.value * 100) / 100) * 1000,
          type: "微信：" + this.valuelist,
          handling_fee: this.list.handling_fee,
          account_token,
      };
      let res = await request("user/person/withdrawal?token=" + getUserToken(), data);
      if (res.error == 0) {
        this.$router.push({
          path: "promotion",
        });
        Toast(res.error_reason);
      } else {
        Toast(res.error_reason);
      }
    }
  },
  mounted() {
    this.withdrawalInfos();
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: rgba(246, 247, 249, 1);
  .home-boundary {
    height: 0.625rem;
  }
  .van-cell__title-titles {
    font-size: 0.9375rem;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    span:first-child {
      padding-top: 0.96875rem;
      padding-bottom: 1.21875rem;
    }
   .van-cell__labels {
      display: flex;
      justify-content: center;
      span {
        font-size: 1.25rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        padding-right: 1.65625rem;
      }
      input {
        margin-left: -0.45625rem;
        font-size: 1.4375rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
  .van-cell__title {
    p {
      font-size: 0.9375rem;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: rgba(74, 74, 74, 1);
    }
    .van-cell__title-money {
      color: #fa6563ff !important;
    }
  }
  .van-cell__title-inputs {
    input {
      margin-left: 2.84375rem;
      border: 0;
    }
  }
  .van-cell__value-value {
    font-size: 1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 53, 51, 1);
  }
  .home-cell__value-boundary {
    padding: 0.75rem 0.59375rem 0.75rem 0.75rem;
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    span {
      display: block;
      padding-top: 0.75rem;
      padding-bottom: 0.625rem;
    }
  }
}
</style>
